import { dev } from '../../apollo/ApolloSetup';

export const exportDocument = async (documentUrl: URL) => {
  if (dev) {
    if (typeof window !== 'undefined') {
      const token = localStorage.getItem('token');

      if (!token) {
        console.error('Token not defined');
        return;
      }

      const response = await fetch(documentUrl, {
        method: 'GET',
        headers: {
          authorization: `Bearer ${token}`, // Attach the auth header
        },
      });

      if (!response.ok) {
        console.error('Failed to fetch the file');
        return;
      }

      const blob = await response.blob(); // Get the file as a Blob
      const blobUrl = window.URL.createObjectURL(blob); // Create a blob URL

      window.open(blobUrl, '_blank');
    }
  } else {
    window.open(documentUrl, '_blank');
  }
};
